// extracted by mini-css-extract-plugin
export var active = "_kq-e";
export var blink = "_kq-f";
export var dropDownSelector = "_kq-5";
export var dropDownWrapper = "_kq-4";
export var fakeCursor = "_kq-d";
export var fontSizeButton = "_kq-7";
export var formQuillEditor = "_kq-0";
export var pressed = "_kq-g";
export var qlBlank = "_kq-1";
export var textFormattingToolbar = "_kq-2";
export var textFormattingToolbarClosed = "_kq-3";
export var textFormattingToolbarInline = "_kq-6";
export var textToolbarOption = "_kq-8";
export var toolbarCell = "_kq-a";
export var toolbarCellCollapsed = "_kq-b";
export var toolbarOptionHitArea = "_kq-c";
export var toolbarOverflow = "_kq-9";